import styled from 'styled-components'
import { Box } from 'rebass'
import media from '../../../utils/style'

export const SearchHeroWrapper = styled(Box)`
  position: relative;
  z-index: 2;

  padding-top: 1px;
  width: 100%;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
`

export const SearchHeroWrapperInner = styled.div`
  background-color: ${(props) => props.theme.colors.blue_light};

  ${media.MediumScreenUp`
    margin: 20px 10px;
  `}

  ${media.LargeScreenUp`
    margin: 40px 20px;
  `}
`

export const SearchHeroHeading = styled.div`
  display: none;
  font-size: 24px;
  line-height: 1.4;
  font-weight: 600;
  color: #292a2d;
  text-align: center;
  margin-top: 50px;
  padding-left: 20px;
  padding-right: 20px;

  ${media.MediumScreenUp`
    display: block;
  `}
  a {
    color: inherit;
  }
`
